import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { recaptchaObject } from "./recaptcha";
import { bookingFormCommon } from "./c005-bookingform-common";
require('parsley');

export class partnerForm {
	private formEl:any = $('#partner-form');
	private $loginError:Array<string> = [];
	$validationSuccess    : any = true;
	// private $newsletterError:Array<string> = [];
	// $newsletterErrorValidation: any = $('.newsletter-error--validation');
	// $newsletterCheckbox: any = $('#groupTnC');
	// $newsletterValidator: any = $('#newsletter-validator');
	$scope: any = $('#partner-form');
	private contactBase:any = new contactForm();$error:Array<any>;

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any { 
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"], input[type="email"], textarea,input[type="checkbox"],input[type="file"]');

		_self.contactBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
	
	
				let _self = this;
	
		var countryInput = $('#partner-form--country');		
		var getCountryOptions = $.Deferred();
		var getCountryOptions = $.Deferred();
		let countrycodeurl:string ='';
		if (window.location.hostname === 'localhost') {
			countrycodeurl = '/dummy-data/countrycode.json';
		}
		else {
			countrycodeurl = '/content/dam/mas/json/countrycode.json';
		}
		$.get(countrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost') {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Countries.length; i++) {
				listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
			}
			getCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getCountryOptions.reject(error);
		});

		
		$.when( getCountryOptions).done(function( countryOptions:any) {		
			countryInput.html(countryOptions);
				let inputSelectArr:any = $.makeArray(_self.formEl.find('select'));
			_self.contactBase.initSelectizeInputs(inputSelectArr);
		});
		$('.partner--form-other-assistance').hide();
		// First Name select
	var	firstName = "<option value=''></option><option value='1'>"+$(".partner--form-first-name-sel").attr("data-nameOption1")+"</option>";
	  firstName += "<option value='2'>"+$(".partner--form-first-name-sel").attr("data-nameOption2")+"</option>";
	  $('#partner-form--first-name-option').html(firstName);
	}
   
	delTicket(): any {
		console.log	(1)
	};
	validateForm(): any {
		
		let _self = this;
        let submitBtn:any = _self.formEl.find('.btn-contact--submit');
        let addMore:any = _self.formEl.find('#assistant-form-more');
		let _window:any   = window;
		let $validationSuccess    : any = true;
		let formData:Array<any> = [];
		let validation:any = _self.formEl.parsley({
			errorClass: 'has-error',
	        classHandler: function (el:any) {
	            return el.$element.closest('.form-item');
			}
        });
		
		$(document).on('click', '.mangu', function(evt:any) {
			evt.currentTarget.parentNode.parentNode.parentNode.parentElement.remove();
			if($('.form-count').length <= 8)
			{
				$('#assistant-form-more').show();
			}else{
				$('#assistant-form-more').hide();
			}
		 });
		 
		 $('input[name=assistant-form--assist]:radio').on('click', function(evt:any) {
			if($('input[name=assistant-form--assist]:radio:checked').val() == "Others"){
				$('.partner--form-other-assistance').show();
			}else{
				$('.partner--form-other-assistance').hide();
			}
		 })
		$('#partner-form--first-name-option').on('change', function(evt:any) {
			
			var label = $(".partner--form-nameSel").attr("data-multi-firstName");	
						
			if(evt.currentTarget.value == 2){
				if($('.partner--form-firstName').length<1){
					$('<div class="form-group partner--form-firstName">'
					+'<div class="row">'
					  +'<div class="col-lg-4 col-md-4 col-sm-4 mobbotspace"> </div>'
						+' <div class="col-lg-4 col-md-4 col-sm-4 mobbotspace partner--form-first-name">'
						+'<div class="form-item">'
						+'<label class="label input-filled" for="partner-form--first-name-selectized ">'+label
						+'  </label>'
						+'  <input class="form-control partner-form--first-name input-focused" name="first-name" type="text" id="partner-form--first-name" required="required" data-parsley-errors-container="#partner-form--first-name--error-container" maxlength="25">'
						+'  <div class="error_msg" id="partner-form--first-name--error-container"></div>'
						+'</div>'
						+' </div>'
						+'</div>'
						+' </div>').insertAfter('.partner--form-nameSel');
				}
					//$('.partner--form-firstName').show();
			}else{
				$('.partner--form-firstName').remove();
			}
		});


		addMore.on('click', function(e:any) {
			if($('.form-count').length <= 8)
			{

				e.currentTarget.parentNode.parentNode.parentNode.insertAdjacentHTML('beforebegin','<div class="form-group partner--form-ticket2 form-count "><div class="row">'
				+'<div class="col-lg-4 col-md-4 col-sm-4 mobbotspace"></div>'
				+'<div class="col-lg-4 col-md-4 col-sm-4 mobbotspace partner--form-Ticket-Number">'
					+'<div class="form-item ">'
					+ '<label class="label" for="partner-form--Ticket-Number">' 
					+ ' </label>'
					+ '<input class="form-control partner-form--Ticket-Number" name="Ticket-Number" type="text" id="partner-form--Ticket-Number1" required="required" data-parsley-errors-container="#partner-form--Ticket-Number--error-container1" maxlength="50" data-parsley-id="13"><span class="mangu"><div class="fa fa-trash" style=" position: absolute; margin-left: 97%;margin-top: -8%;cursor: pointer;"></div></span>'
					+ '<div class="error_msg" id="partner-form--Ticket-Number--error-container1"><ul class="parsley-errors-list filled" id="parsley-id-13"><li class="parsley-required">This value is required.</li></ul></div>'
					+ '</div>'
				+'</div>'
				+'</div></div>');


			//  $('#assistant-form-more').hide();
			}else{
			$('#assistant-form-more').hide();
			}
		});
        
		submitBtn.on('click', function(e:any) {
		e.stopPropagation();
		e.preventDefault();
		let _self = this;
		let fileInputs:any = $('#upload-companycertificate');
		let $loginValidator: any = $('.login-validator');
		let $uploadIdcard : any = $('.upload-companycertificate');
		let scopeAgent:Element = $('.assistance-agent');
		let $validationSuccess:any=true;
		$loginValidator.show();
		
		_self.$loginError = [];
		let fileSize:any,fsize:any;
					let fileName:any;
					let fileExtension:any;
			if (fileInputs.val() != "")
			{
		   if (fileInputs.length) {
						fileInputs.each(function(){
							let fileEl:any = $(this);
							if(fileEl[0].getAttribute('id') == "upload-companycertificate"){
								
								fsize = $(this)[0].files.item(0).size;
								fileSize = ((fsize) / (1024*1024)).toFixed(2);
								fileName =fileEl[0].files[0].name;
								fileExtension = fileName.split('.').pop();
								fileExtension =fileExtension.toLowerCase();
							}
						});
					}
			
					var extensions = ["jpg", "jpeg", "tiff", "png","gif", "bmp","pdf"];
					if (extensions.indexOf(fileExtension) < 0) {
						let $uploadIdcardValidate:any = "&nbsp"+"Not a valid file type, please upload file in following format jpg, jpeg, tff, png, gif, bmp, pdf";
						_self.$loginError.push('<span style="text-transform:capitalize;font-weight:400;font-style:normal;font-family: "mundial", sans-serif,Arial">Upload Company Certificate:</span>'+$uploadIdcardValidate);
						 $validationSuccess = false;	
					}
					else if(fileSize > 5){
						let $uploadIdcardValidate:any = "&nbsp"+"File Size shouldn't be greater than 5MB";
						_self.$loginError.push('<span style="text-transform:capitalize;font-weight:400;font-style:normal;font-family: "mundial", sans-serif,Arial">Upload Company certificate:</span>'+$uploadIdcardValidate);
						 $validationSuccess = false;	
					}else{
						let $validationContainer:any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
						let $validationMessagelist:any = $validationContainer;
						$validationMessagelist.remove();
					}
			}
			
			if(!scopeAgent)
			{


				if($('#partner-form--confirm-email').val() != $('#partner-form--email').val()){
					let $emailValidate:any = "&nbsp"+"Please confirm your email address";
					_self.$loginError.push('<span style="text-transform:capitalize;font-weight:400;font-style:normal;font-family: "mundial", sans-serif,Arial">Email:</span>'+$emailValidate);
					 $validationSuccess = false;	
				}else{
					let $validationContainer:any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
					let $validationMessagelist:any = $validationContainer;
					$validationMessagelist.remove();
				}

				if ($('input[name="assistant-form--assist"]:checked').length == 0) {
					let $choiceValidate:any = "&nbsp"+"This value is required.";
					_self.$loginError.push('<span style="text-transform:capitalize;font-weight:400;font-style:normal;font-family: "mundial", sans-serif,Arial">How can we assist you?:</span>'+$choiceValidate);
					 $validationSuccess = false;	
	
				}else{
					let $validationContainer:any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
					let $validationMessagelist:any = $validationContainer;
					$validationMessagelist.remove();
	
				}
				/*
				if ($('input[name="assistant-form--choose"]:checked').length == 0) {
					let $radioValidate:any = "&nbsp"+"This value is required.";
					_self.$loginError.push('<span style="text-transform:capitalize;font-family: "mundial", sans-serif,Arial"><br/>Please select:</span>'+$radioValidate);
					 $validationSuccess = false;	
	
				}else{
					let $validationContainer:any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
					let $validationMessagelist:any = $validationContainer;
					$validationMessagelist.remove();
	
				} */
			}

			let validationResult:any = validation.validate();
			let $validationContainer:any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');let $validationMessagelist:any = $validationContainer;
			for (var i=0, len=this.$loginError.length; i<len; i++) 
			{
			$validationMessagelist.append('<div data-id="'+i+'" style="color: #ed1c24;font-size: .875rem;margin-left: 7px;height: 28px;">' + this.$loginError[i] + '</li>');
			}

			
			$('.partnerform').on('keyup', function(e:any) 
			{
				if($('.partnerform .error-validation').css('display')=='block')
				{
					$( ".fa-exclamation-triangle " ).remove();
				}
				else
				{
					$( ".fa-exclamation-triangle " ).remove();
					$( ".login-error--validation " ).append( "<div class= fa-exclamation-triangle ></div>");
				}		
			});

			if ( validationResult==true &&  $validationSuccess==false ) {
				$( ".fa-exclamation-triangle " ).remove();
				$( ".login-error--validation " ).append( "<div class= fa-exclamation-triangle ></div>");
			}
			else
			{
				$( ".fa-exclamation-triangle " ).remove();
			}
			if ( validationResult==true &&  $validationSuccess==true )
			{

				let validation:any =$('#partner-form').parsley({
				errorClass: 'has-error',
				classHandler: function (el:any) {
					return el.$element.closest('.form-item');
				}
			});
			let bcommon: any = new bookingFormCommon();
			bcommon.preloader();
			let htmlFormData:any = new FormData(validation.$element[0]);
	        // success fuctions here
			$.ajax({
					type: 'POST',
					url:'/bin/services/new/TravelAgencyAssistanceRequestForm',
					data: htmlFormData,
					success: function(msg:any) {
					let json:any=null;
					if(typeof msg==='string'){
						json = JSON.parse(msg);
					}else{
						json=msg;
					}
					var redirectURL;
					if(json.status == 'true'){
						 redirectURL = $(".assistance-form").attr("data-assistantForm-success");	
						
					}else{
						 redirectURL = $(".assistance-form").attr("data-assistantForm-fail");	
					}
					window.location.href = redirectURL;
			  // bcommon.preloaderClose();
			   },error: function(error:any) {
				//var redirectURL = $(".assistance-form").attr("data-assistantForm-fail");	
				//window.location.href = redirectURL;
				bcommon.preloaderClose();
						},
					cache: false,
					contentType: false,
					processData: false,
				})		
			}
			// console.log(result);
		});

		displayErrorSummaryAtFormTop();

		/**
		 * Consolidate error messages and display at the top of the form
		 */
		function displayErrorSummaryAtFormTop() {
	        // When there's a click on a error message from the div
	        _self.formEl.on('click', 'a[class^="focus-"]', function(){
	        	// take the field's name from the class
				let nameVal:string         = $(this).attr('class').replace(/focus-/g,'');;
				let mabHeaderHeight:number = $('#mab-header').outerHeight();
				let errorField:any         = _self.formEl.find("#" + nameVal);
				let errorFieldPos:number   = 0;

	        	if (isSelectize(errorField)) {
	        		// is selectize element
	        		errorFieldPos = errorField.next().offset().top - mabHeaderHeight - $(window).scrollTop() - errorField.next().outerHeight();
	        	} else {
	        		// every other input field
		        	errorFieldPos = errorField.offset().top - mabHeaderHeight - $(window).scrollTop();
	        	}

	        	// scroll to error element
	        	$("html, body").animate({ scrollTop: errorFieldPos });

	        	// focus on the element after scrolling to it
	        	// - if selectize, click on input field to trigger dropdown open
	        	if (isSelectize(errorField)) {
		        	errorField.next().find('.selectize-input').click();
	        	} else {
		        	errorField.focus();
	        	}
	        });

			if (!document.body.getAttribute('data-form-validate-init')) {
	        	document.body.setAttribute('data-form-validate-init', '1');
				// Before each validation, clear the error-validation of the div
		        _window.Parsley.on('form:validate', function(_form:any) {

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = _form.$element.find('.error-validation');

		            validationSummary.html('');
		            validationSummary.hide();
		        });
			}

			if (!document.body.getAttribute('data-field-error-init')) {
	        	document.body.setAttribute('data-field-error-init', '1');
		        // When a field has an error
		        _window.Parsley.on('field:error', function(fieldInstance:any){
		        	// console.log('field:error', fieldInstance);

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = fieldInstance.parent.$element.find('.error-validation');

		            // Get the error messages
		            // var messages = _window.ParsleyUI.getErrorsMessages(fieldInstance);
		            var messages = fieldInstance.getErrorsMessages();

		            // Get the field's name
		            var fieldId = fieldInstance.$element.attr('id');
					var fieldNameRaw = fieldInstance.$element.attr('name');
					var fieldName    = fieldNameRaw.replace(/--/g, ' ');
					fieldName        = fieldName.replace(/-/g, ' ');

		            // Loop through all the messages
		            for (var i in messages) {
		                // Create a message for each error
		                var $m = $('<p id="error--'+fieldId+'"><a class="focus-' + fieldId + '" href="#">' + '<span class="field-name">' + fieldName + ': </span>' + messages[i] + '</a><p>');

		                let fieldIdExists:any = validationSummary.find('#error--'+fieldId);

		                // Append the errors to the div if not shown
		                if (fieldIdExists.length) {
		                	fieldIdExists.remove();
			                validationSummary.append($m);
		                } else {
			                validationSummary.append($m);
		                }
		            }

		        	validationSummary.show();
		        });
		    }
		}

		/**
		 * test if field is selectize input
		 * @param {any} el [jquery object - input element to test]
		 * @return boolean
		 */
		function isSelectize(el:any) {
        	if (el.prop('type') == 'select-one' && el.hasClass('selectized')) {
        		return true;
        	} else {
        		return false;
        	}
		}
	}
	
	initRecaptcha():any {

		let _self = this;
		let _body = $('body');
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'partner-form-registration-recaptcha',
			cb: 'recaptchaCorporateSuccess',
			cbObj:	function () {
								(document.getElementById('partner-form-registration-recaptcha') as HTMLInputElement).value = 'true';
							},
			displayId: 'partner-registration--grecaptcha',
			formEl: _self.formEl
		};
		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}

	partnerForm(): any {
		let _self = this;
		_self.$scope.find('#partner-form-submit').click((evt: any) => {
         
			var nav = $('.partnerform');
			if (nav.length) {
				var contentNav = nav.offset().top;
	             }
				 $('html, body').animate({ scrollTop: '100px' });
		});
	}
}

let scope:Element = document.querySelector('.assistance-form');
if (scope){
	try {
	let partnerform = new partnerForm();
		$('.form-about--success').show();
		partnerform.initTextInputs();
		partnerform.initSelectizeInputs();
		partnerform.delTicket();
		partnerform.validateForm();
        partnerform.partnerForm();
		
	} catch(e) {console.error(e);}
}